import React from 'react';
import { func } from 'prop-types';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { getStartedUrl } from '../../../constants/urls';
import './style.scss';

const DiscoverIdeasMakeYourLogo = ({ onStartClick }) => (
    <div className="discover-ideas-make-your-logo">
        <div className="container">
            <h2>
                <I18n k="logo_maker_perseus.general.make_your_logo" />
            </h2>
            <p>
                <I18n k="logo_maker_perseus.discover_logo_ideas.make_your_logo.description" />
            </p>
            <Button
                className="discover-ideas-btn"
                href={getStartedUrl()}
                onClick={onStartClick}
                color={Button.COLORS.BLUE}
            >
                <I18n k="logo_maker_perseus.general.start_now" />
            </Button>
        </div>
    </div>
);

DiscoverIdeasMakeYourLogo.propTypes = {
    onStartClick: func,
};

export default DiscoverIdeasMakeYourLogo;
